import { CancelShiftRequestObj } from "../common/CommonInterfaces";
import emailjs from "emailjs-com";

import {
  ServerResponse,
  RemoteExecutionServiceImpl,
  RemoteGETCallInputObject,
} from "../remoteExecution/RemoteExecutionServiceImpl";
import { AxiosResponse } from "axios";
import {OrgMetaData, CorpDataObj} from '../orgViews/orgConstants';
import {
  Email,
  JobberOrgRatingClientResp,
  JobberProfileResp,
  JobberProfileReq,
  JobberResumeReq,
  JobberResume,
  GetJobberProfileAPIResp,
  CorpDetailsCorpZip,
} from "../orgViews/orgConstants";
import { EmailAddress } from "../common/CommonInterfaces";
import { ca } from "date-fns/locale";
import {
  getSessionStorageValue,
  setSessionStorageValue,
} from "../common/CommonUtilsMethods";
import { LOCAL_STORAGE_KEYS } from "../common/CommonUtilsMethods";

const backendApiBasePathLocal =
  process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL;
const remoteCallObject = RemoteExecutionServiceImpl();

/** Returns true when the server accepted the cancel; callers should refetch shift data instead of reloading the page. */
const CancelShiftRequestAPICall = async ({ shiftId }: { shiftId: string }): Promise<boolean> => {
  if (!shiftId) {
    return false;
  }

  const apiBody: CancelShiftRequestObj = {
    shiftId: shiftId,
  };

  try {
    const response: AxiosResponse<ServerResponse<string, Error>> =
      await remoteCallObject.remotePOSTCallV2<
        ServerResponse<string, Error>,
        CancelShiftRequestObj
      >({
        apiUrl: backendApiBasePathLocal + "shiftassignment/cancel",
        object: apiBody,
        headers: { "Content-Type": "application/json" },
      });
    console.log("!!!!!POST request successful:", response);

    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      return true;
    }
    return false;
  } catch (e) {
    if (
      e.response &&
      (e.response.status === 400 || e.response.status === 500)
    ) {
      console.log("400 or 500");
    }
    console.error("POST request failed:", e);
    return false;
  }
};

const SendErrorEmailv2 = async () => {
  // e.preventDefault();

  const serviceID = "service_3mlm2ls";
  const templateID = "template_xl6xpjw";
  const userID = "zKdgUxA7H3dMaCf-m";

  const fullname =
    getSessionStorageValue({key: LOCAL_STORAGE_KEYS.FIRST_NAME}) + " " + getSessionStorageValue({key: LOCAL_STORAGE_KEYS.LAST_NAME});
  const orgemail = getSessionStorageValue({key: LOCAL_STORAGE_KEYS.USER_EMAIL});
  const emailReason = "!URGENT! ERROR SENDING SHIFT REQUEST";
  const emailMessage =
    fullname +
    " from  " +
    getSessionStorageValue({key: LOCAL_STORAGE_KEYS.ORG_NAME}) +
    " tried sending a shift request but failed. REQUIRES IMMEDIATE ATTENTION. \n\n" +
    "First Name : " +
    getSessionStorageValue({key: LOCAL_STORAGE_KEYS.FIRST_NAME}) +
    "\n" +
    "Last Name : " +
    getSessionStorageValue({key: LOCAL_STORAGE_KEYS.LAST_NAME}) +
    "\n" +
    "Org Name : " +
    getSessionStorageValue({key: LOCAL_STORAGE_KEYS.ORG_NAME}) +
    "\n" +
    "Phone Number : " +
    getSessionStorageValue({key: LOCAL_STORAGE_KEYS.USER_PHONE_NUMBER}) +
    "\n" +
    "Email : " +
    orgemail +
    "\n";

  try {
    // await emailjs.sendForm(serviceID, templateID, "hello", userID);
    await emailjs.send(
      serviceID,
      templateID,
      {
        user_fullname: fullname,
        user_email: orgemail,
        user_reason: emailReason,
        user_message: emailMessage,
      },
      userID
    );

    console.log("Email Sent Successfully!");
  } catch (error) {
    console.log("An error occurred while sending the email.");
    console.error(error);
  }
};

const GetJobberResume = async (jobberEmail: EmailAddress) => {
  const jobberReq2: JobberResumeReq = {
    value: jobberEmail.value,
  };

  try {
    const response: AxiosResponse<ServerResponse<JobberResume, Error>> =
      await remoteCallObject.remotePOSTCallV2<
        ServerResponse<JobberResume, Error>,
        JobberResumeReq
      >({
        apiUrl: backendApiBasePathLocal + "v2/jobber/download/resume/",
        object: jobberReq2,
        headers: { "Content-Type": "application/json" },
      });
    console.log("POST request successful:", response);
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      window.open(response.data.data.toString());
    }
  } catch (e) {
    console.error(
      "The worker resume could not be retrieved at this time, please try again later.",
      e
    );
    alert(
      "The worker resume could not be retrieved at this time, please try again later."
    );
  }
};

const GetJobberProfile = async (
  jobberEmail: string
): Promise<GetJobberProfileAPIResp> => {
  try {
    if (typeof jobberEmail !== "string") {
      throw new Error("Invalid jobberEmail type");
    }

    const jobberReq: JobberProfileReq = {
      jobberEmail: { value: jobberEmail },
    };

    const response: AxiosResponse<ServerResponse<JobberProfileResp, Error>> =
      await remoteCallObject.remotePOSTCallV2<
        ServerResponse<JobberProfileResp, Error>,
        JobberProfileReq
      >({
        apiUrl: backendApiBasePathLocal + "v2/jobber/profile/details/",
        object: jobberReq,
        headers: { "Content-Type": "application/json" },
      });

    console.log("POST request successful:", response);

    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      console.log("here");
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.jobberQuickSummary
      ) {
        // setProfileText(response.data.data.jobberQuickSummary);
        // setProfilePic(response.data.data.jobberProfilePicS3Url);
        return {
          jobberProfilePicS3Url: response.data.data.jobberProfilePicS3Url,
          jobberQuickSummary: response.data.data.jobberQuickSummary,
          jobberFullDetails: response.data.data.jobberFullDetails,
          workyJobberRating: response.data.data.workyJobberRating,
          userDetails: response.data.data.userDetails,
        };
      }
    }
  } catch (e) {
    console.error("Error fetching jobber profile:", e);
    // Replace the undefined function call with the correct one
  }
  return {
    jobberProfilePicS3Url: "",
    jobberQuickSummary: "",
    jobberFullDetails: "",
    workyJobberRating: "",
    userDetails: {
      userId: "",
      firstName: "",
      lastName: "",
      userEmail: { value: "" },
      userPhoneNumber: { value: "" },
    },
  };
};

const GetJobberRatingV3 = async (
  jobberEmail: string
): Promise<JobberOrgRatingClientResp> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl:
      backendApiBasePathLocal + "jobber/performance/rating/org/single-jobber",
    headers: {},
    queryParams: {
      jobberEmail: jobberEmail,
    },
  };

  try {
    const jobberRating: AxiosResponse<
      ServerResponse<JobberOrgRatingClientResp, Error>
    > = await remoteCallObject.remoteGETCallV2<
      ServerResponse<JobberOrgRatingClientResp, Error>
    >(getCallInput);

    if (jobberRating && jobberRating.data && jobberRating.data.data) {
      return jobberRating.data.data;
    }
  } catch (e) {}

  return {
    jobberDetails: {
      userId: "",
      firstName: "",
      lastName: "",
      userEmail: { value: "" },
      userPhoneNumber: { value: "" },
    },
    orgName: "",
    jobberOrgRatingDetailMap: new Map(),
    jobberProfileImageS3Url: "",
  };
};

// Your function
const GetOrgMetadata = async (): Promise<OrgMetaData | undefined> => {
    const getCallInput: RemoteGETCallInputObject = {
      apiUrl: backendApiBasePathLocal + "org/metadata",
      headers: {},
      queryParams: null,
    };
    
    try {
      const orgMetadataRes: AxiosResponse<ServerResponse<OrgMetaData, Error>> =
        await remoteCallObject.remoteGETCallV2<ServerResponse<OrgMetaData, Error>>(getCallInput);
  
      if (orgMetadataRes && orgMetadataRes.data && orgMetadataRes.data.data) {
        setSessionStorageValue({key: LOCAL_STORAGE_KEYS.ORG_NAME, value: orgMetadataRes.data.data.orgName});
        setSessionStorageValue({key: LOCAL_STORAGE_KEYS.ORG_DATA, value: JSON.stringify(orgMetadataRes.data.data)});
        return orgMetadataRes.data.data;
      }
    } catch (error) {
      console.error('Error fetching organization metadata:', error);
      throw new Error('Error fetching organization metadata');
    }
  };



const GetCorpDetails = async (): Promise<CorpDataObj> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: backendApiBasePathLocal + "corp/details",
    headers: {},
    queryParams: null,
  };
  
  try {
    const orgMetadataRes: AxiosResponse<ServerResponse<CorpDataObj, Error>> =
      await remoteCallObject.remoteGETCallV2<ServerResponse<CorpDataObj, Error>>(getCallInput);      

    if (orgMetadataRes && orgMetadataRes.data && orgMetadataRes.data.data) {      
      setSessionStorageValue({key: LOCAL_STORAGE_KEYS.ORG_NAME, value: orgMetadataRes.data.data.corpJobberDetails.corpName});
      setSessionStorageValue({key: LOCAL_STORAGE_KEYS.ORG_DATA, value: JSON.stringify(orgMetadataRes.data.data)});
      return orgMetadataRes.data.data;
    }
  } catch (error) {
    console.error('CorpDataObj:', error);
    throw new Error('CorpDataObj metadata');
  }
};

/**
 * Endpoint to retrieve lightweight corp details containing only corp name, type, and icon URL
 */
const GetCorpDetailsZip = async (): Promise<CorpDetailsCorpZip | undefined> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: backendApiBasePathLocal + "corp/details-zip",
    headers: {},
    queryParams: null,
  };
  
  try {
    const corpDetailsZipRes: AxiosResponse<ServerResponse<CorpDetailsCorpZip, Error>> =
      await remoteCallObject.remoteGETCallV2<ServerResponse<CorpDetailsCorpZip, Error>>(getCallInput);

    if (corpDetailsZipRes?.data?.data) {      
      setSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.ORG_NAME, 
        value: corpDetailsZipRes.data.data.corpJobberDetails.corpName
      });
      return corpDetailsZipRes.data.data;
    }
  } catch (error) {
    console.error('Error fetching corp details zip:', error);
    throw new Error('Error fetching corp details zip');
  }
};


export {
  CancelShiftRequestAPICall,
  SendErrorEmailv2,
  GetJobberResume,
  GetJobberProfile,
  GetJobberRatingV3,
  GetOrgMetadata,
  GetCorpDetails,
  GetCorpDetailsZip
};
